import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { degreeCategories } from '../data/degrees';
import { Logo } from './Logo';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const popularPrograms = [{
    name: 'Business',
    path: '/degrees/business'
  }, {
    name: 'Computer Science',
    path: '/degrees/computer-science'
  }, {
    name: 'Nursing',
    path: '/degrees/healthcare'
  }, {
    name: 'Criminal Justice',
    path: '/degrees/criminal-justice'
  }, {
    name: 'Psychology',
    path: '/degrees/psychology'
  }];
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-413" data-mp="36bbitll9kyoh">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-414" data-mp="3baeisrme0epl">
        <div className="flex justify-between items-center h-20" data-id="element-415" data-mp="3b81vdyxv1c55">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-416" data-mp="3fbzvabv0eqz9">
            <Link to="/" className="flex items-center" aria-label="findonlinecolleges.org home" data-id="element-417" data-mp="2wl4eqo7g82f5">
              <Logo data-id="element-418" data-mp="2rli14dnpkk5t" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-419" data-mp="2mm57na2c0eu9">
            <div className="relative" onMouseEnter={() => setIsDropdownOpen(true)} onMouseLeave={() => setIsDropdownOpen(false)} data-id="element-420" data-mp="2mohtvzf4hbd4">
              

              {/* Dropdown Menu */}
              {isDropdownOpen && <div className="absolute top-full left-0 w-64 bg-white shadow-lg rounded-b-lg border border-gray-100 py-2 z-50" data-id="element-421" data-mp="3fd6rvpkvt0kn">
                  {degreeCategories.map(category => <Link key={category.id} to={`/degrees/${category.id}`} className="block px-4 py-2 text-sm text-gray-700 hover:bg-light hover:text-navy hover:font-medium" onClick={() => setIsDropdownOpen(false)} data-id="element-422" data-mp="35jy9sa54skql">
                      {category.name}
                    </Link>)}
                </div>}
            </div>

            <Link to="/get-matched" className="inline-flex items-center bg-crimson hover:bg-crimson-dark text-white font-semibold text-sm px-5 py-2.5 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-crimson" style={{
            backgroundColor: "#E3924E"
          }} data-id="element-423" data-mp="3t90opa8drzhe">
              Find My Match
            </Link>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-424" data-mp="1mks05wjc6fp0">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-navy hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-navy" data-id="element-425" data-mp="18m0ki5otslyr">
              <span className="sr-only" data-id="element-426" data-mp="13nz5bvuit6sk">Open main menu</span>
              {isMobileMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-427" data-mp="13q37o9crtxqq" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-428" data-mp="2t3yl3vsn9uh6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-b border-gray-200 shadow-inner" data-id="element-429" data-mp="me50go1n0jot">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-430" data-mp="hfl8o70d4doj">
            <div className="px-3 py-2 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-431" data-mp="hheks1tqvq3x">
              All Degree Categories
            </div>
            {degreeCategories.map(category => <Link key={category.id} to={`/degrees/${category.id}`} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-navy hover:bg-gray-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-432" data-mp="rczihnrs647v">
                {category.name}
              </Link>)}

            <div className="pt-3 pb-1 px-3" data-id="element-433" data-mp="1f3lpdbq1tiga">
              <Link to="/get-matched" onClick={() => setIsMobileMenuOpen(false)} className="block w-full text-center bg-crimson hover:bg-crimson-dark text-white font-semibold text-base px-5 py-3 rounded-md transition-colors duration-200" data-id="element-434" data-mp="1f19870s47c4a">
                Find My Match
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}